import MvMetadataGapReviewTab from "../MusicAssetAuditComponents/MvMetadataGapReview";

const MvMetadataGapsRoute = () => <MvMetadataGapReviewTab />;

export default MvMetadataGapsRoute;
